import type { AvatarProps, AvatarSize } from '@cheqroom/components/Avatar';
import { Avatar as SharedAvatar } from '@cheqroom/components/Avatar';
import type { FC } from 'react';

// Can't `export { Avatar } from '@cheqroom/components/Avatar'` directly: that package resolves its own
// (React 19) @types/react, whose `ReactNode` also permits `bigint`/`Promise<ReactNode>` — not assignable
// to this package's React 18 `ReactNode`, so every JSX call site (Point.tsx, AvatarGroup, ...) fails with
// "'Avatar' cannot be used as a JSX component." Re-typing it here, once, avoids that at every use site.
export const Avatar = SharedAvatar as unknown as FC<AvatarProps>;
export type { AvatarProps as Props, AvatarSize as Size };
